export default __webpack_public_path__ + "static/media/hellstrikes3.0efb411e.png";